<template>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel profile-panel profile-team">
                <template v-if="sports.length">
                    <h3 class="text-center" v-text="$t('wi.additional_sports')"></h3>
                    <div id="teams">
                        <div class="tw-mb-12" v-for="(sport, index) in sports">
                            <div class="tw-flex tw-justify-between tw-items-start tw-border-b tw-border-grey-light tw-pb-6 tw-mb-4">
                                <div class="tw-flex tw-flex-col">
                                    <span class="tw-font-thin" v-if="sport.start_year && sport.end_year">{{ `${sport.start_year} - ${sport.end_year}` }}</span>
                                    <strong v-text="sport.name"></strong>
                                </div>
                                <div class="tw-flex tw-justify-end tw-items-center">
                                    <delete-button
                                        :item-id="additionalSportsData[index].id"
                                        type="additional_sports"
                                        :message="`${$t('wi.sure_to_delete')} ${sport.name} ${$t('wi.sport_from_your_profile')}`"
                                    />
                                    <edit-button
                                            modal-target="editAdditionalSport"
                                            :modal="{title: $t('wi.edit_your_sport'), index}"
                                    />
                                </div>
                            </div>
                            <p class="tw-my-6" v-text="sport.comments"></p>
                        </div>
                        <add-button modal-target="editAdditionalSport" :modal="{title: $t('wi.add_your_sport_information')}"/>
                    </div>
                </template>
                <empty-state
                        v-else
                        :title="$t('wi.additional_sports')"
                        :description="`${$t('wi.more_to_life')} ${sportName}. ${$t('wi.other_sports_you_play')}`"
                        :button="{caption: $t('wi.add_additional_sports')}"
                        :modal="{title: $t('wi.add_your_sport_information')}"
                        modalTarget='editAdditionalSport'
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import EditButton from '../VisualElements/EditButton';
    import DeleteButton from '../VisualElements/DeleteButton';
    import AddButton from '../VisualElements/AddButton';
    import EmptyState from '../EmptyState';
    import academyMixin from '../../mixins/academy';

    export default {
        name: "AdditionalSport",
        mixins: [academyMixin],
        components: {
            EditButton,
            DeleteButton,
            AddButton,
            EmptyState
        },
        computed: {
            ...mapGetters({
                additionalSportsData: 'player-profile/additionalSports'
            }),
            sports() {
                return this.additionalSportsData.map(team => {
                    return team.metas[0].value;
                });
            },
            sportName() {
                return this.getSportName();
            }
        }
    }
</script>

<style scoped>

</style>